import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="text-3xl font-bold mb-6">개인정보처리방침</h1>
      <div className="space-y-6">
        <section>
          <h2 className="text-xl font-semibold mb-3">1. 개인정보의 처리 목적</h2>
          <p className="text-gray-600">
            회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며,
            이용 목적이 변경되는 경우에는 개인정보 보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
          </p>
        </section>
        {/* 추가 섹션들... */}
      </div>
    </div>
  );
};

// default export 추가
export default PrivacyPolicy;